module.exports = __webpack_public_path__ + "img/detail-website.9d0993aa.svg";